import { Translation } from '@ps/web-shared-components';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { BaseHeader, useWidgetTheme } from '@swf/poker';

import styles from '../../Club/Wall/shared.scss';
import type { WallPosts } from '../../Club/Wall/utils/normalizeWallPosts';

import {
  TXTCLI_Are_you_sure_you_want_to_delet_ELL_6,
  TXTCLI_Cancel,
  TXTCLI_Confirm_delete,
  TXTCLI_Delete_Message
} from './DeleteThread.messages.json';

interface Props {
  thread: WallPosts;
  handleDelete: () => void;
  loading: boolean;
}

const DeleteThread: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const {
    state: { thread, handleDelete, loading }
  } = useLocation<Props>();
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const userId = useSelector(select.account.getUserId);
  const { className } = useWidgetTheme();

  const confirmDelete = () => {
    handleDelete();
    modal.close();
  };

  const handleClose = () => {
    modal.close();
  };

  useEffect(() => {
    setStyle({
      overlayClassName: className,
      className: styles.modalContainer,
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  return (
    <>
      <BaseHeader
        headerClassName={styles.header}
        title={<Translation {...TXTCLI_Delete_Message} />}
      />
      <Body className={styles.modalBody}>
        <p>
          <Translation {...TXTCLI_Are_you_sure_you_want_to_delet_ELL_6} />
        </p>
        <div className={styles.wallComment}>
          <div className={styles.info}>
            <span className={userId === thread.userId ? styles.usernameOwn : styles.username}>
              {thread.userId}
            </span>
          </div>

          <p className={styles.content}>{thread.content}</p>
        </div>
      </Body>
      <div className={styles.deleteThreadButtons}>
        <StarsButton
          className={styles.actionButton}
          variant="secondary"
          disabled={loading}
          onClick={handleClose}
          translation={TXTCLI_Cancel}
        />
        <StarsButton
          className={styles.actionButton}
          variant="primary"
          disabled={loading}
          onClick={confirmDelete}
          translation={TXTCLI_Confirm_delete}
        />
      </div>
    </>
  );
};

export default DeleteThread;
